import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../_redux/invoicesActions';
import can from '../../../_common/components/Permissions/can';

const PopupReopenInvoice = ({cellContent}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {_id, status, type} = cellContent;
  const isEnabled = status === 2 && type !== 2 && can('full', 'invoices');
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${isEnabled ? `` : `opacity-30`}`;
  const buttonOpen = intl.formatMessage({
    id: 'invoices-button-reopenInvoice',
    defaultMessage: 'Reopen invoice',
  });
  const message = intl.formatMessage({
    id: 'invoices-popup-reopenInvoice-message',
    defaultMessage: 'Should i reopen the invoice {id}',
  }, {id: _id});
  const buttonConfirm = intl.formatMessage({
    id: 'invoices-popup-reopenInvoice-button-confirm',
    defaultMessage: 'Confirm',
  });
  const buttonCancel = intl.formatMessage({
    id: 'invoices-popup-reopenInvoice-button-cancel',
    defaultMessage: 'Cancel',
  });

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (isEnabled) {
            handleShowModal()
          }
        }}
      >
        {buttonOpen}
        <img
          src={toAbsoluteUrl('/media/svg/Repeat_brandColor.svg')}
          alt="icon"
          className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <div className={'w-100 mb-12 d-flex justify-content-center font-weight-bold font-size-lg'}>
            {message}
          </div>
          <div className="d-flex justify-content-center">
            <Button
              className="btn-secondary mx-3 btn-sm w-100px"
              onClick={handleCloseModal}
            >
              {buttonCancel}
            </Button>
            <Button
              type="submit"
              className="btn-sm mx-3 custom-send-button w-100px"
              disabled={!isEnabled}
              onClick={() => {
                dispatch(actions.reopenInvoiceAction(_id));
                handleCloseModal();
              }}
            >
              {buttonConfirm}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

PopupReopenInvoice.propTypes = {
  _id: PropTypes.string,
  status: PropTypes.number,
  type: PropTypes.number,
};

export default PopupReopenInvoice;
